import type { CameraReportReasonId } from '../../models/entities/camera-report.model';

/** Dealer `POST /case` `caseName` enums. */
export const DEALER_CASE_NAME_BY_REASON = {
  'camera-obstruction': 'CameraObstruction',
  'poor-lighting': 'PoorLighting',
  'generating-false-alarm': 'GeneratingFalseAlarm',
} as const satisfies Record<CameraReportReasonId, string>;

export type DealerCaseName =
  (typeof DEALER_CASE_NAME_BY_REASON)[CameraReportReasonId];

/** Maps a report-reason id to the Dealer caseName enum. */
export function mapCameraReportReasonToDealerCaseName(
  reasonId: CameraReportReasonId,
): DealerCaseName {
  return DEALER_CASE_NAME_BY_REASON[reasonId];
}
